/**
 * Outbound Amazon links. Every "Buy on Amazon" target in the app is built here so
 * the Associates tag only has to be added in one place once the account is live.
 */

/** Set to the Associates tag (e.g. "giftgaff0e-20") to monetize every product link. */
export const AMAZON_AFFILIATE_TAG = "giftgaff0e-20";

const AMAZON_ORIGIN = "https://www.amazon.com";

function withAffiliateTag(url) {
  if (!AMAZON_AFFILIATE_TAG) return url;
  const joiner = url.includes("?") ? "&" : "?";
  return `${url}${joiner}tag=${encodeURIComponent(AMAZON_AFFILIATE_TAG)}`;
}

/** Canonical product detail page for an ASIN. */
export function amazonProductUrl(asin) {
  if (typeof asin !== "string" || !asin.trim()) return null;
  return withAffiliateTag(`${AMAZON_ORIGIN}/dp/${asin.trim()}`);
}

/** Search fallback for recommendations that have no ASIN of their own. */
export function amazonSearchUrl(query) {
  const q = typeof query === "string" ? query.trim() : "";
  if (!q) return withAffiliateTag(`${AMAZON_ORIGIN}/`);
  return withAffiliateTag(`${AMAZON_ORIGIN}/s?k=${encodeURIComponent(q)}`);
}

/**
 * Best available Amazon target for a recommendation card: an explicit product URL,
 * then its ASIN, then a title search so the CTA is never a dead end.
 */
export function amazonUrlForRec(rec) {
  if (!rec || typeof rec !== "object") return amazonSearchUrl("");
  if (typeof rec.productUrl === "string" && rec.productUrl.trim()) {
    return withAffiliateTag(rec.productUrl.trim());
  }
  return amazonProductUrl(rec.asin) ?? amazonSearchUrl(rec.fullTitle || rec.title);
}
